/**
 * @generated SignedSource<<da17d4ad227c820c29508d0593921d0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmployeeEditUploadLinkMutation$variables = Record<PropertyKey, never>;
export type EmployeeEditUploadLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type EmployeeEditUploadLinkMutation = {
  response: EmployeeEditUploadLinkMutation$data;
  variables: EmployeeEditUploadLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeEditUploadLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmployeeEditUploadLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3bce8cb7a280e846a6b3d4a1a5468e18",
    "id": null,
    "metadata": {},
    "name": "EmployeeEditUploadLinkMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeEditUploadLinkMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "eac6ca21bb09d32c522f0a0c0883c200";

export default node;
